module.exports = __webpack_public_path__ + "img/ring_tanzoUchinuki.6f9604c0.png";